var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaterialDeleteForever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.911,
    height: 19.172,
    viewBox: "0 0 14.911 19.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8.565,21.542a2.136,2.136,0,0,0,2.13,2.13h8.521a2.136,2.136,0,0,0,2.13-2.13V8.76H8.565Zm2.62-7.583,1.5-1.5,2.269,2.258,2.258-2.258,1.5,1.5-2.258,2.258,2.258,2.258-1.5,1.5-2.258-2.258L12.7,19.976l-1.5-1.5,2.258-2.258Zm7.5-8.393L17.618,4.5H12.293L11.228,5.565H7.5V7.7H22.411V5.565Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialDeleteForever);
export default __webpack_public_path__ + "static/media/Icon-material-delete-forever.a2c82c90b0ff777ad2ca4a4376e0bf78.svg";
export { ForwardRef as ReactComponent };